import React, { useState } from "react";

import { FileUp } from "lucide-react";

import ToolbarIconButton from "../ToolbarIconButton";
import ImportJsonDialog from "./ImportJsonDialog";

export default function ImportJson() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ToolbarIconButton
        tooltip="Import JSON"
        icon={<FileUp className="size-4" />}
        onClick={() => setOpen(true)}
      />
      {open && <ImportJsonDialog onClose={() => setOpen(false)} />}
    </>
  );
}
